/**
 * 日期对比大数字组件
 * 用于展示指标在不同时间段的对比数据，包括变化百分比和气泡提示信息
 */

import React from 'react';
import { useIntl } from 'umi';
import { LANGUAGE_EN } from '@home/_config/config';
import SingleBigNumber from "@customComp/BigNumberChart/SingleBigNumber";
import DatalabGrid from '@/pages/datalab/components/DatalabGrid';
import MetricChangeBox from '@/pages/datalab/components/MetricUpAndDownComponents/MetricChangeBox';
import MetricVsBubble from '@/pages/datalab/components/MetricUpAndDownComponents/MetricVsBubble';
import MetricChangePercent from '@/pages/datalab/components/MetricUpAndDownComponents/MetricChangePercent';
import './index.scss';

interface ITimeComparison {
  name_en: string;
  name_cn: string;
  date: string;
  value: string;
  percent: number;
}

interface IDateCompareBigNumbersProps {
  timeComparisons?: ITimeComparison[];
  staticTime?: string;
  content?: React.ReactNode;
}

const DateCompareBigNumbers: React.FC<IDateCompareBigNumbersProps> = ({
  timeComparisons,
  staticTime,
  content,
}) => {
  const { formatMessage, locale } = useIntl();
  const isEn = locale === LANGUAGE_EN;

  return (<>
    <SingleBigNumber
      content={content}
    />
    <DatalabGrid colCount={2} gap={20} columnWidthMode="max-content">
      {timeComparisons?.map((item, index) => (
        <React.Fragment
          key={`${item.name_en}-${item.date}-${item.value}-${index}`}
        >
          <MetricVsBubble
            data={[
              {
                leftTitle: `${formatMessage({ id: 'dbl_common_change' })}%`,
                rightTitle: <MetricChangePercent value={item.percent} />,
                thisTime: staticTime,
                lastTime: item.date,
                thisValue: content,
                lastValue: item.value,
              },
            ]}
          >
            <MetricChangeBox
              title={isEn ? item.name_en : item.name_cn}
              change={item.percent}
            />
          </MetricVsBubble>
        </React.Fragment>
      )) ?? []}
    </DatalabGrid>
  </>
  );
};

export default DateCompareBigNumbers;